import ActionButton from 'components/ActionButton';
import BackButton from 'components/BackButton';
import { Loading } from 'components/loading/Loading';
import React, { useEffect, useState } from 'react';
import { fetchRecipe } from 'services';
import { showError } from 'utils';
import BasicDetails from './basicDetails';
import styles from './index.module.scss';
import InventoryItemsForRecipe from './inventoryItemForRecipe';

const RecipeDetails = (props) => {
  const { recipeId } = props.match.params;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({}) as any;

  const fetchRecipeFn = async () => {
    setLoading(true);
    try {
      const response = await fetchRecipe(recipeId);
      setData(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecipeFn();
  }, []);

  const getHeader = () => (
    <div className={styles['header']}>
      <div className={styles['heading']}>Recipe Details</div>
      <div className={styles['header-buttons']}>
        <BackButton />
        <ActionButton
          text={'Edit'}
          active={true}
          isLoading={false}
          onClick={() => {
            props.history.push(`/recipes/edit/${recipeId}`);
          }}
        />
      </div>
    </div>
  );

  const getStepsHeader = () => {
    return (
      <div className={styles['section-heading']}>
        Steps
      </div>
    );
  };

  const getSteps = () => {
    return (
      <>
        {getStepsHeader()}
        {data?.steps && data.steps.map((i: any) => {
          return (
            <div key={i}>
              <ul className='list-group'>
                <li className='list-group-item'>{i}</li>
              </ul>
            </div>);
        })}
      </>
    );
  };

  return (
    <div id={'main-container'} className={styles['main-container']}>
      {loading && <Loading />}
      {getHeader()}
      <BasicDetails details={data} />
      {getSteps()}
      <InventoryItemsForRecipe recipeId={recipeId} />
    </div>
  );
};

export default RecipeDetails;